import { useContext } from "react";
import {
  AUTH_ERROR,
  FORM_SUBMISSION,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  USER_LOADED,
  USER_LOADING,
} from "../actions/type";
import { AuthContext } from "../contexts/AuthContext";
import { handleApiCall } from "../services/httpConfig";

const useAuthState = () => {
  const { auth, dispatchAuth } = useContext(AuthContext);

  // login existing user
  const login = async (data) => {
    try {
      const payload = JSON.stringify(data);
      dispatchAuth({ type: USER_LOADING });
      dispatchAuth({ type: FORM_SUBMISSION });
      const response = await handleApiCall("api/auth/login", "POST", payload);
      dispatchAuth({ type: LOGIN_SUCCESS, payload: response.data });
      return response;
    } catch (err) {
      console.log(err);
    }
  };

  const logout = async () => {
    try {
      const response = await handleApiCall("api/auth/logout", "POST", null);
      dispatchAuth({ type: LOGOUT_SUCCESS });
      return response;
    } catch (err) {
      console.log(err);
    }
  };

  const loadUser = async () => {
    try {
      dispatchAuth({ type: USER_LOADING });
      const response = await handleApiCall("api/auth/user", "GET");
      dispatchAuth({ type: USER_LOADED, payload: response.data });
    } catch (err) {
      dispatchAuth({ type: AUTH_ERROR });
      console.log(err);
    }
  };

  return { login, loadUser, logout, auth };
};

export default useAuthState;
